(() => {
  class LeoRepairHomeStore extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.input = this.querySelector('[data-store-input]');
      this.form = this.querySelector('[data-store-form]');
      this.reset = this.querySelector('[data-store-reset]');
      this.status = this.querySelector('[data-store-status]');
      this.searchArea = this.querySelector('[data-store-search]');
      this.results = this.querySelector('[data-store-results]');
      this.resultsHeading = this.querySelector('[data-store-results-heading]');
      this.nearbyHeading = this.querySelector('[data-store-nearby-heading]');
      this.noResults = this.querySelector('[data-store-no-results]');
      this.noNearby = this.querySelector('[data-store-no-nearby]');
      this.nearbyActions = this.querySelector('[data-store-nearby-actions]');
      this.list = this.querySelector('.leo-repair-home-store__list');
      this.selectors = Array.from(this.querySelectorAll('[data-store-select]'));
      this.originalSelectors = this.selectors.slice();
      this.panels = Array.from(this.querySelectorAll('[data-store-panel]'));
      this.postcodeDataUrl = this.dataset.postcodeDataUrl;
      this.distanceRadius = Number(this.dataset.distanceRadius) || 50;
      this.postcodeData = null;
      this.postcodeRequest = null;
      this.abortController = null;
      this.searchToken = 0;
      if (!this.input || !this.form || !this.results || !this.list || !this.selectors.length) return;

      this.classList.add('leo-repair-home-store--enhanced');
      this.searchArea.hidden = false;
      this.handleSubmit = (event) => {
        event.preventDefault();
        this.filter(this.input.value);
      };
      this.handleInput = () => this.filter(this.input.value);
      this.handleReset = () => {
        this.input.value = '';
        this.filter('');
        this.input.focus();
      };
      this.handleKeydown = (event) => {
        if (event.key === 'Escape') {
          this.input.value = '';
          this.filter('');
        }
      };
      this.form.addEventListener('submit', this.handleSubmit);
      this.input.addEventListener('input', this.handleInput);
      this.input.addEventListener('keydown', this.handleKeydown);
      this.reset.addEventListener('click', this.handleReset);
      this.handleResultsClick = (event) => {
        const eventTarget = event.target instanceof Element ? event.target : null;
        const selector = eventTarget ? eventTarget.closest('[data-store-select]') : null;
        if (!selector || !this.results.contains(selector) || !this.contains(selector)) return;
        this.select(selector.dataset.storeSelect);
      };
      this.results.addEventListener('click', this.handleResultsClick);
      this.handleBlockSelect = (event) => {
        const eventTarget = event.target instanceof Element ? event.target : null;
        const selector = eventTarget ? eventTarget.closest('[data-store-select]') : null;
        if (!selector || !this.contains(selector)) return;
        if (selector.hidden) {
          this.input.value = '';
          this.filter('');
        }
        this.select(selector.dataset.storeSelect);
      };
      document.addEventListener('shopify:block:select', this.handleBlockSelect);
      this.select(this.selectors[0].dataset.storeSelect);
      this.filter('');
    }

    disconnectedCallback() {
      if (this.form && this.handleSubmit) this.form.removeEventListener('submit', this.handleSubmit);
      if (this.input && this.handleInput) this.input.removeEventListener('input', this.handleInput);
      if (this.input && this.handleKeydown) this.input.removeEventListener('keydown', this.handleKeydown);
      if (this.reset && this.handleReset) this.reset.removeEventListener('click', this.handleReset);
      if (this.results && this.handleResultsClick) this.results.removeEventListener('click', this.handleResultsClick);
      if (this.handleBlockSelect) document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      if (this.abortController) this.abortController.abort();
      this.classList.remove('leo-repair-home-store--enhanced');
      this.removeAttribute('data-initialized');
      this.form = null;
      this.input = null;
      this.reset = null;
      this.status = null;
      this.searchArea = null;
      this.results = null;
      this.resultsHeading = null;
      this.nearbyHeading = null;
      this.noResults = null;
      this.noNearby = null;
      this.nearbyActions = null;
      this.list = null;
      this.selectors = [];
      this.originalSelectors = [];
      this.panels = [];
      this.postcodeData = null;
      this.postcodeRequest = null;
      this.abortController = null;
      this.handleSubmit = null;
      this.handleInput = null;
      this.handleReset = null;
      this.handleKeydown = null;
      this.handleResultsClick = null;
      this.handleBlockSelect = null;
    }

    normalize(value) {
      return value.toLocaleLowerCase().trim().replace(/\s+/g, ' ');
    }

    filter(value) {
      const token = ++this.searchToken;
      if (this.abortController) this.abortController.abort();
      this.abortController = null;
      this.postcodeRequest = null;
      this.originalSelectors.forEach((selector) => this.list.appendChild(selector));
      if (this.resultsHeading) this.resultsHeading.hidden = false;
      if (this.nearbyHeading) this.nearbyHeading.hidden = true;
      if (this.noNearby) this.noNearby.hidden = true;
      if (this.nearbyActions) this.nearbyActions.hidden = true;
      this.selectors.forEach((selector) => {
        const distance = selector.querySelector('[data-store-distance]');
        if (distance) { distance.hidden = true; distance.textContent = ''; }
      });
      const query = this.normalize(value);
      const exactPostcode = /^\d{4}$/.test(query);
      const terms = query ? query.split(' ') : [];
      const matches = exactPostcode
        ? this.selectors.filter((selector) => selector.dataset.storePostcode === query)
        : this.selectors.filter((selector) => {
          const text = this.normalize(selector.dataset.storeSearch || '');
          return terms.every((term) => text.includes(term));
        });
      this.selectors.forEach((selector) => { selector.hidden = !matches.includes(selector); });
      if (matches.length) {
        this.noResults.hidden = true;
        const active = matches.find((selector) => selector.classList.contains('is-active')) || matches[0];
        this.select(active.dataset.storeSelect);
        this.status.textContent = `${matches.length} ${matches.length === 1 ? 'store' : 'stores'} found`;
        return;
      }
      this.panels.forEach((panel) => { panel.hidden = true; });
      this.selectors.forEach((selector) => selector.setAttribute('aria-pressed', 'false'));
      if (exactPostcode && this.postcodeDataUrl) {
        this.noResults.hidden = true;
        this.status.textContent = 'Searching nearby stores…';
        this.recommend(query, token);
      } else {
        this.noResults.hidden = false;
        this.status.textContent = 'No matching stores found';
      }
    }

    async recommend(postcode, token) {
      try {
        const data = await this.loadPostcodeData();
        if (token !== this.searchToken) return;
        const origin = data.postcodes && data.postcodes[postcode];
        if (!origin) return this.showNoNearby();
        const recommendations = this.selectors.map((selector, index) => {
          const coords = data.postcodes[selector.dataset.storePostcode];
          return coords ? { selector, index, distance: this.haversine(origin, coords) } : null;
        }).filter(Boolean).filter((item) => item.distance <= this.distanceRadius)
          .sort((a, b) => a.distance - b.distance || a.index - b.index).slice(0, 2);
        if (!recommendations.length) return this.showNoNearby();
        this.resultsHeading.hidden = true;
        this.nearbyHeading.hidden = false;
        this.noResults.hidden = true;
        if (this.nearbyActions) this.nearbyActions.hidden = true;
        this.selectors.forEach((selector) => { selector.hidden = true; });
        recommendations.forEach((item) => {
          this.list.appendChild(item.selector);
          item.selector.hidden = false;
          const distance = item.selector.querySelector('[data-store-distance]');
          if (distance) { distance.hidden = false; distance.textContent = `Approximately ${Math.round(item.distance)} km away`; }
        });
        this.select(recommendations[0].selector.dataset.storeSelect);
        this.status.textContent = `${recommendations.length} nearby ${recommendations.length === 1 ? 'store' : 'stores'} found`;
      } catch (error) {
        if (error.name !== 'AbortError' && token === this.searchToken) this.showNoResults();
      }
    }

    async loadPostcodeData() {
      if (this.postcodeData) return this.postcodeData;
      if (!this.postcodeRequest) {
        this.abortController = new AbortController();
        const request = fetch(this.postcodeDataUrl, { signal: this.abortController.signal }).then((response) => {
          if (!response.ok) throw new Error('postcode data unavailable');
          return response.json();
        }).then((data) => { this.postcodeData = data; return data; });
        this.postcodeRequest = request;
        request.then(() => { if (this.postcodeRequest === request) this.postcodeRequest = null; }, () => { if (this.postcodeRequest === request) this.postcodeRequest = null; });
      }
      return this.postcodeRequest;
    }

    showNoNearby() {
      this.resultsHeading.hidden = true;
      this.nearbyHeading.hidden = true;
      this.noResults.hidden = true;
      this.noNearby.hidden = false;
      if (this.nearbyActions) this.nearbyActions.hidden = false;
      this.status.textContent = 'No nearby stores found';
    }

    showNoResults() {
      this.resultsHeading.hidden = false;
      this.nearbyHeading.hidden = true;
      this.noNearby.hidden = true;
      if (this.nearbyActions) this.nearbyActions.hidden = true;
      this.noResults.hidden = false;
      this.status.textContent = 'No matching stores found';
    }

    haversine(origin, destination) {
      const radians = (value) => value * Math.PI / 180;
      const [lat1, lon1] = origin;
      const [lat2, lon2] = destination;
      const dLat = radians(lat2 - lat1);
      const dLon = radians(lon2 - lon1);
      const a = Math.sin(dLat / 2) ** 2 + Math.cos(radians(lat1)) * Math.cos(radians(lat2)) * Math.sin(dLon / 2) ** 2;
      return 6371 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    select(id) {
      const selected = this.selectors.find((selector) => selector.dataset.storeSelect === id);
      if (!selected || selected.hidden) return;
      this.selectors.forEach((selector) => {
        const active = selector === selected;
        selector.classList.toggle('is-active', active);
        selector.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.storePanel !== id;
        panel.classList.toggle('is-hidden', panel.dataset.storePanel !== id);
      });
    }
  }

  if (!customElements.get('leo-repair-home-store')) {
    customElements.define('leo-repair-home-store', LeoRepairHomeStore);
  }
})();
